import { Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-module-placeholder',
  standalone: true,
  template: `
    <section class="placeholder">
      <i class="fa-solid fa-screwdriver-wrench" aria-hidden="true"></i>
      <h1>{{ title }}</h1>
      <p>Módulo preparado para migración.</p>
    </section>
  `,
  styles: [
    `
      .placeholder {
        display: grid;
        justify-items: center;
        gap: 8px;
        padding: 80px 20px;
        color: var(--text-secondary);
        text-align: center;
      }
      .placeholder i {
        color: var(--blue);
        font-size: 32px;
      }
      h1 {
        margin: 0;
        color: var(--text-primary);
        font-size: 22px;
      }
      p {
        margin: 0;
        font-size: 13px;
      }
    `,
  ],
})
export class ModulePlaceholderComponent {
  private readonly route = inject(ActivatedRoute);
  protected readonly title = this.route.snapshot.data['title'] as string;
}
